import { Typography } from "antd";
import WeddingDayStyle from "../assests/Red Modern Happy Anniversary Instagram Post.png";
import TestImage from "../assests/TestImage.jpg";

const { Title, Paragraph, Text } = Typography;

export default function WeddingAnniversary({employee}) {
    const employeeName = employee?.user?.first_name;
    const spouseName = employee?.spouse_name;
    const organizationName = employee?.organisation_name;
    const departmentName =  employee?.department_name;
    const designation = employee?.designation_name;

    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    background: "transparent",
                }}
            >
                <div
                    style={{
                        position: "relative",
                        width: "400px",
                        height: "600px",
                        background: "white",
                        borderRadius: "10px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        overflow: "hidden",
                    }}
                >
                    {/* Background Template */}
                    <img
                        src={WeddingDayStyle}
                        alt="Wedding Anniversary Template"
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                             objectFit: "cover",
                            zIndex: 1,
                        }}
                    />

                   

                    {/* Couple Info */}
                    <div
                        style={{
                            position: "absolute",
                            top: "190px",
                            left: 0,
                            right: 0,
                            textAlign: "center",
                            zIndex: 3,
                            padding: "0 20px",
                            color: "#2e2e2e",
                        }}
                    >
                        <Title
                            level={4}
                            style={{
                                fontFamily: "Georgia, serif",
                                color: "#b22222",
                                marginBottom: "6px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {employeeName} ❤️ {spouseName}
                        </Title>

                        <Text
                            style={{
                                display: "block",
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "#4a4a4a",
                                marginBottom: "2px",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {designation} - {departmentName}
                        </Text>

                        <Text
                            strong
                            style={{
                                display: "block",
                                fontSize: "12px",
                                color: "#b22222",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {organizationName}
                        </Text>
                    </div>

                    {/* Anniversary Wish */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: "215px",
                            left: "0",
                            right: "0",
                            textAlign: "center",
                            padding: "0 40px",
                            zIndex: 3,
                            color: "#5a3e36",
                        }}
                    >
                        <Paragraph
                            style={{
                                fontSize: "13px",
                                color: "#4a4a4a",
                                fontFamily: "Georgia, serif",
                                lineHeight: "1.5",
                            }}
                        >
                            Wishing you both a lifetime filled with love, laughter, 
                            and endless happiness. 💖
                            <br />
                            <b>
                                Warm wishes from the entire <br />
                                <span style={{ color: "#b22222" }}>
                                    Baashyaam Group Family!
                                </span>
                            </b>
                        </Paragraph>
                    </div>
                </div>
            </div>
        </>
    );
}
